const _ = "styles-module__alert___INHtE", t = "styles-module__alert_container___yroWf", o = "styles-module__icon_close___Ki7Yf", s = "styles-module__body___5LyPQ", e = "styles-module__icon___sSi-2", n = "styles-module__title___3nRk5", l = "styles-module__sub_title___9cqnD", c = "styles-module__actions_desktop___V1dO8", i = "styles-module__actions___lvapI", a = "styles-module__action_button___FyRrq", d = "styles-module__button_secondary___iKl4s", u = {
  alert: _,
  alert_container: t,
  icon_close: o,
  body: s,
  icon: e,
  title: n,
  sub_title: l,
  actions_desktop: c,
  actions: i,
  action_button: a,
  button_secondary: d
};
export {
  a as action_button,
  i as actions,
  c as actions_desktop,
  _ as alert,
  t as alert_container,
  s as body,
  d as button_secondary,
  u as default,
  e as icon,
  o as icon_close,
  l as sub_title,
  n as title
};
